module.exports = __webpack_public_path__ + "img/sex1.04082f4d.png";